module.exports = __webpack_public_path__ + "static/img/page8-bg.fc1e33f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page8-bg.png
// module id = HYhM
// module chunks = 216